import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Money from '../../Common/Money/Money';
import styles from './summary.module.css';

const SummaryProducts = ({ reservationInfo }) => {
  const { t } = useTranslation();

  const getUnits = (p) => {
    if (p.specialType) {
      return p.quantity + ' ' + t('productType.' + p.specialType + '.unit');
    } else if (p.reservationType === 'AREA') {
      return p.quantity;
    } else {
      return p.quantity * p.paxsPerItem + ' pax';
    }
  };

  const renderSeatMapProduct = () => {
    if (!reservationInfo.products.some((x) => x.seats !== null)) return;

    return (
      <>
        <table className='w-100'>
          <thead>
            <tr className='font-smaller'>
              <th>{t('items')}</th>
              <th className='text-right'>{t('price')}</th>
            </tr>
          </thead>
          <tbody>
            {reservationInfo?.products
              .filter((x) => x.seats !== null)
              .map((p, index) => (
                <Fragment key={index}>
                  <tr>
                    <td className={index !== 0 ? 'pt-3' : ''}>
                      <span className='fw-500 font-normal2'>{p.productName}</span>
                      <div className='text-tertiary'>{p.seats}</div>
                    </td>
                    <td
                      className={`text-right align-top fw-500 font-normal2 text-tertiary ${
                        index !== 0 ? 'pt-3' : ''
                      }`}
                    >
                      <Money value={p.amountPerUnit} symbolSize='14px' />
                    </td>
                  </tr>
                  {p.extraPaxs > 0 && (
                    <tr>
                      <td className='text-tertiary'>
                        {p.extraPaxs} {t('extraGuest', { count: p.extraPaxs })}
                      </td>
                      <td className='text-right align-top fw-500 font-normal2 text-tertiary'>
                        <Money value={p.totalAmountExtraPaxs} symbolSize='14px' />
                      </td>
                    </tr>
                  )}
                </Fragment>
              ))}
          </tbody>
        </table>
      </>
    );
  };

  const renderProducts = () => {
    if (!reservationInfo.products.some((x) => x.seats === null)) return;
    const isCourtesy = reservationInfo.products.some((x) => x.isCourtesy);

    return (
      <>
        <table className='w-100'>
          <thead>
            <tr className='font-smaller'>
              <th>{t('items')}</th>
              <th className={`pl-3 ${isCourtesy ? 'text-right' : 'text-center'}`}>{t('quantityAbbr')}</th>
              {!isCourtesy && <th className='text-right pl-3'>{t('price')}</th>}
            </tr>
          </thead>
          <tbody>
            {reservationInfo?.products
              .filter((x) => x.seats === null)
              .map((p, index) => (
                <Fragment key={index}>
                  <tr className='fw-600'>
                  <td className='text-truncate' style={{ maxWidth: 100 }}>
                      <span className='text-truncate'>{p.productName}</span>
                    </td>
                    <td
                      className={`align-top text-tertiary py-1 pl-3 ${styles.autoWidth} ${
                        p.isCourtesy ? 'text-right' : 'text-center'
                      }`}
                    >
                      {getUnits(p)}
                    </td>
                    {!p.isCourtesy && (
                      <td className={`text-right align-top text-tertiary py-1 pl-3 ${styles.autoWidth}`}>
                        <Money value={p.totalAmountWithoutExtraPaxs} symbolSize='14px' />
                      </td>
                    )}
                  </tr>

                  {p.extraPaxs && p.extraPaxs > 0 ? (
                    <tr>
                      <td className='position-relative py-1'>{t('extraGuest')}</td>
                      <td className={p.isCourtesy ? 'text-right py-1' : 'text-center py-1'}>
                        {p.extraPaxs} {t('productType.EXTRAPAX.unit')}
                      </td>
                      {!p.isCourtesy && (
                        <td className='text-right py-1'>
                          <Money value={p.totalAmountExtraPaxs} symbolSize='14px' />
                        </td>
                      )}
                    </tr>
                  ) : null}
                </Fragment>
              ))}
          </tbody>
        </table>
      </>
    );
  };

  return (
    <>
      {renderSeatMapProduct()}
      {renderProducts()}
    </>
  );
};

export default SummaryProducts;
